import {
  Component,
  OnInit,
  ViewEncapsulation,
  AfterViewInit,
  OnDestroy,
  NgZone,
  Input
} from '@angular/core';
import { AppLoadingService } from '../../_services/common/loading.service';
import { DashboardService } from '../../_services/main/dashboard.service';
import { AlertService } from '../../_services/common/alert.service';
import { AuthService } from '../../_services/main/auth.service';
import { Helpers } from '../../helpers';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import * as $ from 'jquery';

@Component({
  selector: 'app-sticky-chat',
  templateUrl: './sticky-chat.component.html',
  styleUrls: ['./sticky-chat.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StickyChatComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  customerDetails: any;
  private currentUser: any = {};
  conversations: any = [];
  chat: any;
  customer: any;
  //chatsIntervalVar: any;
  constructor(
    private _spinnerService: AppLoadingService,
    private _dashboardService: DashboardService,
    private _alertService: AlertService,
    private _authService: AuthService
  ) {}
  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('CURRENT_USER')); // employee
  }

  ngAfterViewInit() {
    // when the client hits ENTER on their keyboard
    // $('body').on('keypress', "input", function(e) {
    //     if (e.which == 13 && e.target.className.indexOf("m-messenger__form-input") > -1) {
    //         this.onSendText();
    //     }
    // }.bind(this));
    // this.chatsIntervalVar = setInterval(function(){
    //   if (this.customerDetails && this.customerDetails.phone){
    //     this.getChats(this.customerDetails.phone);
    //   }
    // }.bind(this), 60000);
  }

  ngOnChanges() {
    if (this.customerDetails && this.customerDetails.phone) {
      this.customer = this.customerDetails;
      this.getChats(this.customer.phone);
    }
  }

  ngOnDestroy() {
    //clearInterval(this.chatsIntervalVar);
  }
  onSendText() {
    if (this.chat == null || this.chat.trim() == '') return;
    let newText = {
      out: true,
      _id: this.customerDetails._id,
      phoneNumber: this.customerDetails.phone,
      message: this.chat,
      timestamp: new Date(),
      employeeId: this.currentUser._id
    };
    this.conversations.push(newText);
    this.chat = '';
    this.saveChat(newText);
    //$(".m-scrollable").scrollTop($('.m-scrollable')[0].scrollHeight);
  }

  saveChat(text) {
    this._dashboardService.sendText(text).subscribe((response: any) => {
      console.log(response);
    });
  }

  getChats(phone) {
    this._dashboardService.fetchChats(phone).subscribe((response: any) => {
      if (response.data.result) {
        this.conversations = [];
        response.data.chat.forEach(item => {
          let chat = null;
          if (
            !item._source ||
            !item._source.text ||
            (item._source.text && item._source.text.trim() == '')
          )
            return;
          if (item._source && item._source.to == item._source.id) {
            chat = {
              out: true,
              in: false,
              message: item._source.text,
              timestamp: item._source.date
            };
            //console.log("incoming: ", item._source.text)
          } else if (item._source && item._source.from == item._source.id) {
            chat = {
              in: true,
              out: false,
              message: item._source.text,
              timestamp: item._source.date
            };
            //console.log("outgoing: ", item._source.text)
          }
          if (chat != null) this.conversations.push(chat);
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sticky-chat/sticky-chat.component.ts